module.exports = __webpack_public_path__ + "img/hr-boiler-N-idle.437ded0d.png";